var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"common-image",style:(_vm.styleObj)}):_c('div',{staticClass:"common-image"},[_vm._v("未指定图像")])}
var staticRenderFns = []

export { render, staticRenderFns }